


















import {
  computed,
  defineComponent,
  getCurrentInstance
} from "@vue/composition-api";
import OccLabel from "@/components/Atoms/OccLabel/index.vue";
import { sendGaEvent } from "@/helpers/ga-helper";

export interface Props {
  checked: boolean | Function;
  value: number | string;
  name: string;
  label: string;
  disabled: boolean;
  bold: boolean;
  color: string;
  size: string;
  gaEventCategory: string;
}

export default defineComponent({
  name: "OccRadio",
  components: {
    OccLabel
  },
  inheritAttrs: false,
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Number, String, Boolean],
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    bold: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: "gray60"
    },
    size: {
      type: String,
      default: "large"
    },
    gaEventCategory: {
      type: String,
      default: ""
    }
  },
  setup(props: Props) {
    const classes = computed(() => [
      { "occ-radio--checked": props.checked },
      { "occ-radio--disabled": props.disabled }
    ]);

    const instance = getCurrentInstance();
    const handleClick = () => {
      if (instance)
        sendGaEvent(instance.proxy, {
          gaEventLabel: { value: props.value, label: props.label }
        });
    };

    return { classes, handleClick };
  }
});
